class ObjectionCarousel extends HTMLElement {
  connectedCallback() {
    this.viewport = this.querySelector('.objection-carousel__viewport');
    this.track = this.querySelector('[data-oc-track]');
    this.prevButton = this.querySelector('[data-oc-prev]');
    this.nextButton = this.querySelector('[data-oc-next]');
    this.progressBar = this.querySelector('[data-oc-progress-bar]');

    if (!this.viewport || !this.track) return;

    this.prevButton?.addEventListener('click', () => {
      this.pauseAutoplay();
      this.scrollByCards(-1);
    });
    this.nextButton?.addEventListener('click', () => {
      this.pauseAutoplay();
      this.scrollByCards(1);
    });
    this.viewport.addEventListener('scroll', () => this.updateState(), { passive: true });
    window.addEventListener('resize', () => this.updateState());

    this.updateState();
    this.initAutoplay();
  }

  disconnectedCallback() {
    this.stopAutoplay();
  }

  scrollByCards(direction) {
    const card = this.track.querySelector('[data-oc-card]');
    const cardWidth = card ? card.getBoundingClientRect().width : this.viewport.clientWidth;
    const gap = parseFloat(getComputedStyle(this.track).gap) || 0;
    const maxScroll = this.viewport.scrollWidth - this.viewport.clientWidth;

    if (direction > 0 && this.viewport.scrollLeft >= maxScroll - 1) {
      this.viewport.scrollTo({ left: 0, behavior: 'smooth' });
      return;
    }

    this.viewport.scrollBy({ left: direction * (cardWidth + gap), behavior: 'smooth' });
  }

  updateState() {
    const maxScroll = this.viewport.scrollWidth - this.viewport.clientWidth;
    const scrolled = this.viewport.scrollLeft;

    if (this.prevButton) this.prevButton.disabled = scrolled <= 1;
    if (this.nextButton) this.nextButton.disabled = maxScroll <= 1 || (scrolled >= maxScroll - 1 && this.dataset.autoplay !== 'true');

    if (this.progressBar) {
      const viewportRatio = Math.min(this.viewport.clientWidth / this.viewport.scrollWidth, 1);
      const progress = maxScroll > 0 ? scrolled / maxScroll : 0;
      const barWidth = viewportRatio * 100;
      const travel = 100 - barWidth;
      this.progressBar.style.width = barWidth + '%';
      this.progressBar.style.transform = `translateX(${progress * travel}%)`;
    }
  }

  initAutoplay() {
    if (this.dataset.autoplay !== 'true') return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    this.autoplayDelay = parseInt(this.dataset.autoplayDelay, 10) || 4000;

    this.startAutoplay();

    ['mouseenter', 'touchstart', 'focusin'].forEach((evt) => {
      this.addEventListener(evt, () => this.pauseAutoplay(), { passive: true });
    });
    ['mouseleave', 'touchend', 'focusout'].forEach((evt) => {
      this.addEventListener(evt, () => this.startAutoplay(), { passive: true });
    });

    document.addEventListener('visibilitychange', () => {
      if (document.hidden) {
        this.stopAutoplay();
      } else {
        this.startAutoplay();
      }
    });
  }

  startAutoplay() {
    if (this.autoplayTimer) return;
    this.autoplayTimer = window.setInterval(() => {
      this.scrollByCards(1);
    }, this.autoplayDelay);
  }

  pauseAutoplay() {
    this.stopAutoplay();
  }

  stopAutoplay() {
    if (this.autoplayTimer) {
      window.clearInterval(this.autoplayTimer);
      this.autoplayTimer = null;
    }
  }
}

if (!customElements.get('objection-carousel')) {
  customElements.define('objection-carousel', ObjectionCarousel);
}
